import { render, staticRenderFns } from "./NextBeltProgressText.vue?vue&type=template&id=8d34a89c&"
import script from "./NextBeltProgressText.vue?vue&type=script&lang=js&"
export * from "./NextBeltProgressText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./NextBeltProgressText.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports